const About = () => (
  <div data-testid="about-page">
    <section className="relative h-[50vh] md:h-[65vh] overflow-hidden">
      <img
        src="https://customer-assets-cm19k8pv.emergentagent.net/job_premium-wear-104/artifacts/lr7lhi6x_image.png"
        alt="Shashikala and Varshini — Vastra West founders"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-black/30" />
      <div className="relative h-full flex flex-col items-center justify-center text-white text-center px-6">
        <p className="overline">Our Story</p>
        <h1 className="font-serif-display text-5xl md:text-7xl italic mt-3">A Quieter Kind of Luxury</h1>
      </div>
    </section>

    <section className="max-w-3xl mx-auto px-6 py-24 md:py-32">
      <p className="font-serif-display text-3xl md:text-4xl italic leading-tight">
        When we first spoke about starting a business together, fashion wasn't just an idea — it was something we genuinely loved.
      </p>
      <div className="mt-10 text-[color:var(--vw-ink-soft)] leading-relaxed space-y-6">
        <p>We wanted to create a brand that reflected our personalities and offered people clothing that felt as good as it looked.</p>
        <p>Although our professional journeys were different, our vision was the same. Shashikala spent over fifteen years in the IT industry, while Varshini spent more than twelve years as a lecturer. Those experiences shaped who we are — and gave us the confidence to leap into something we had always dreamed of building together.</p>
        <p>That's how Vastra West was born in Bengaluru.</p>
        <p>From the very beginning, we knew we didn't want to create clothes just to follow trends. We wanted to curate pieces that people could wear with confidence — styles that are elegant, comfortable, and made for everyday moments as much as special ones.</p>
        <p>Every collection we bring to Vastra West is a reflection of what we believe in: quality, timeless design, and effortless style. As we continue to grow, our hope is simple — to become a part of your journey and help you feel confident every time you choose to wear Vastra West.</p>
      </div>
      <p className="mt-12 font-serif-display text-2xl italic">— Shashikala & Varshini, Vastra West</p>
    </section>

    <section className="max-w-[1400px] mx-auto px-6 md:px-12 pb-24 md:pb-32 grid grid-cols-1 md:grid-cols-3 gap-6">
      {[
        { t: "Small Runs", d: "No overproduction. Every silhouette is made in limited quantities." },
        { t: "Natural Fabrics", d: "Silk, linen, cotton, gabardine. Nothing that doesn't breathe." },
        { t: "Fair Ateliers", d: "We know every tailor by name. And they know us." },
      ].map(v => (
        <div key={v.t} className="pt-6">
          <p className="overline">{v.t}</p>
          <p className="mt-3 font-serif-display text-xl">{v.d}</p>
        </div>
      ))}
    </section>
  </div>
);

export default About;
